import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table'
import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Ckeyword(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>
      
      <Helmet>
 
 <title>Learn Free PHP Keyword Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php Keywords tutorial for beginners.In Phpkeywords cannot be used as identifiers CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php mysql keyword search,keyword generator php,php keywords,tutorial for begineers,Php Keywords,keyword in php,php keyword use" />
 <link rel="canonical" href="https://www.codeexampler.com/php-keyword" />
 </Helmet>


 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php keywords</h1>
    <div className="first">
        <a href="/php-setup">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">
1, Php keywords cannot be used as identifiers<br/>
2, They cannot use as names for a variable, class, or method..<br/>
3, Php Programming keywords are Known as Reserved Words.

</p>
<h2 className="mt-4 mh2">Php keyword programming table</h2>
    <Table responsive striped bordered hover variant="dark m-3">
 
 <tbody>
   <tr>
     
     <td>abstract</td>
     <td>and</td>
     <td>array</td>
     <td>as</td>
     <td>break</td>
     <td>callable</td>
     <td>case</td>
     <td>catch</td>
   </tr>
   <tr>
    
     <td>class</td>
     <td>clone</td>
     <td>cost</td>
     <td>continue</td>
     <td>declare</td>
     <td>default</td>
     <td>die</td>
     <td>do</td>
   </tr>
   <tr>
   
     <td>echo</td>
     <td>else</td>
     <td>elseif</td>
     <td>empty</td>
     <td>enddeclare</td>
     <td>endfor</td>
     <td>endforeach</td>
     <td>endif</td>
    
   </tr>

   <tr>
   
     <td>endswitch</td>
     <td>endwhile</td>
     <td>eval()</td>
     <td>exit()</td>
     <td>extends</td>
     <td>final</td>
     <td>finally</td>
     <td>for</td>
   </tr>

   <tr>
     
     <td>foreach</td>
     <td>function</td>
     <td>global</td>
     <td>goto</td>
     <td>if</td>
     <td>implements</td>
     <td>include</td>
     <td>include_once</td>
   </tr>

   <tr>
     
     <td>instanceof</td>
     <td>insteadof</td>
     <td>interface</td>
     <td>isset()</td>
     <td>list()</td>
     <td>namespace()</td>
     <td>new</td>
     <td>or</td>
   </tr>

   <tr>
     
     <td>print</td>
     <td>private</td>
     <td>protected</td>
     <td>public</td>
     <td>require</td>
     <td>require_once</td>
     <td>return</td>
     <td>static</td>
   </tr>

   <tr>
     
     <td>switch</td>
     <td>throw</td>
     <td>trait</td>
     <td>try</td>
     <td>unset()</td>
     <td>use</td>
     <td>var</td>
     <td>while</td>
   </tr>

   


   <tr>
     
     <td>xor</td>
     <td>yield</td>
     <td>yield_from</td>
   </tr>

 </tbody>
</Table>
  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/php-setup">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Ckeyword;